import { useTranslation } from "react-i18next";
import { TabPanel, TabPanels } from "@chakra-ui/react";

import { Category } from "../Category";

import stepRegistry from "../../stepRegistry";
import { useSelector } from "react-redux";
import { useCallback } from "react";

export const CHANGE_ACTIONS = Object.freeze({
  NEXT: "next",
  PREV: "prev",
  PREV_SECTION: "prevSection"
});

function TabStepsPanels({
                          defaultValues,
                          onTabChange,
                          categories,
                          finalize,
                          tabsCollapsed,
                          finalizeQuestionnaire,
                          setFinalize,
                          onSectionChange,
                          returnToList,
                          returnToListRequested,
                          declineReturnToListRequest,
                          isPreview
                        }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3"
  });
  const action = useSelector(state => state.questionnaire.action);

  const handleCategoryChange = useCallback(() => {
    switch (action) {
      case CHANGE_ACTIONS.NEXT:
        onTabChange((prev) => prev + 1);
        break;
      case CHANGE_ACTIONS.PREV:
        onTabChange((prev) => prev - 1);
        break;
      case CHANGE_ACTIONS.PREV_SECTION:
        onSectionChange();
        break;
      default:
        if (action !== "") {
          onTabChange(action);
        }
    }

    if (returnToListRequested === true) {
      returnToList();
    }
  }, [action, onTabChange, onSectionChange, returnToList, returnToListRequested]);

  return (
    <TabPanels maxWidth={`calc(100% - var(--chakra-sizes-${tabsCollapsed ? 12 : 60}))`}>
      {categories.map((tabKey, index) => {
        const formTitle = `${t(`categories.${tabKey}`, { number: index + 1 })}`;
        const FormComponent = stepRegistry.resolve(tabKey);
        const CustomHeaderComponent = !isPreview ? stepRegistry.resolveCustomHeader(tabKey) : null;
        const customHeaderProps = stepRegistry.resolveCustomHeaderProps(tabKey);

        return (
          <TabPanel key={`tabpanel_${tabKey}`} blockSize="full" padding="0">
            <Category
              title={formTitle}
              tabKey={tabKey}
              shouldShowPrev={index > 0}
              shouldShowNext={index < categories.length - 1}
              categories={categories}
              CustomHeaderComponent={CustomHeaderComponent}
              questionnaireId={defaultValues?.id}
              customHeaderProps={customHeaderProps}
              isPreview={isPreview}
            >
              <FormComponent
                tabKey={tabKey}
                defaultValues={defaultValues}
                handleCategoryChange={handleCategoryChange}
                finalize={finalize}
                finalizeQuestionnaire={finalizeQuestionnaire}
                setFinalize={setFinalize}
                declineReturnToListRequest={declineReturnToListRequest}
                isPreview={isPreview}
              />
            </Category>
          </TabPanel>
        );
      })}
    </TabPanels>
  );
}

export default TabStepsPanels;
